<template>
 <div class="select">
   <h4 class="title1">
     <span>&nbsp;&nbsp;查询条件</span>
   </h4>
    <div class="selectColor">
      <div class="row">
        <el-row :gutter="20">
            <el-col :span="7">
              <el-row>
                <el-col :span="4">
                  机构
                </el-col>
                <el-col :span="17">
                  <el-cascader placeholder="请输入" :options="options" filterable change-on-select v-model="manageCom"> </el-cascader>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="7">
              <el-row>
                <el-col :span="7">销售人员</el-col>
                <el-col :span="17">
                  <el-input class="input" v-model="agentName" placeholder="请输入销售人员名称"></el-input> 
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="7">
              <el-row>
                <el-col :span="9">销售人员编码</el-col>
                <el-col :span="15">
                  <el-input class="input" v-model="agentCode"  placeholder="请输入销售人员编码"></el-input> 
                </el-col>
              </el-row>
            </el-col>
        </el-row>
        <el-row>
          <div class="right">
            <el-button type="primary" @click="search()">查询</el-button>
          </div>
        </el-row> 
      </div>
        <h4 class="title1"><span>&nbsp;&nbsp;查询结果</span> <el-button class="right" type="primary" @click="exportResult">导出</el-button></h4>
        <el-table :data="result" style="width: 100%">
          <el-table-column type="index" width="120" label="编号" align="center"> </el-table-column>
          <el-table-column prop="t2Name" label="T2名称"  align="center"> 
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.t2Name">{{ scope.row.t2Name }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="t2Code" label="T2代码"  align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.t2Code">{{ scope.row.t2Code }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="t3Name" label="T3名称"  align="center" >
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.t3Name">{{ scope.row.t3Name }}</div>
              <div slot="reference" v-else>-</div>
            </template>
         </el-table-column>
          <el-table-column prop="t3Code" label="T3代码"  align="center" > 
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.t3Code">{{ scope.row.t3Code }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="t4Name" label="T4名称"  align="center" >
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.t4Name">{{ scope.row.t4Name }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="t4Code" label="T4代码" align="center" > 
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.t4Code">{{ scope.row.t4Code }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="agentName" label="销售人员姓名"  align="center" > 
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.agentName">{{ scope.row.agentName }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="agentCode" label="销售人员编码"  align="center" >
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.agentCode">{{ scope.row.agentCode }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
           <el-table-column prop="saleRiskNum" label="在售险种总数"  align="center" >
              <template slot-scope="scope">
                <div slot="reference" v-if="scope.row.saleRiskNum">{{ scope.row.saleRiskNum }}</div>
                <div slot="reference" v-else>-</div>
              </template>
          </el-table-column>
          <el-table-column prop="authNum" label="已授权险种数量"  align="center"> 
            <!-- <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.authNum">{{ scope.row.authNum }}</div>
              <div slot="reference" v-else>-</div>
            </template> -->
          </el-table-column>
        </el-table>
        <div class="footer">
          <el-pagination
            class="my-pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            :current-page="currentPage1"
            layout="total, sizes, prev, pager, next, jumper"
            prev-click
            next-click
            :total="count">
          </el-pagination>
      </div>
    </div>
 </div>
</template>
<script>
import api from '@/modules/api.js';
import url from '@/modules/url.js';
export default {
  data(){
    return {
      manageCom:[],
      options: [{}],
      manageCom1:[],
      manageComList:[],
      agentName:'',
      agentCode:'',
      T3: false,
      T4: false,
      requestData:{
        org:'HO',
        agentCode:null,
        agentName:null,
        pageSize:10,
        currentPage:1,
      },
      result:[],
      count:0,
      currentPage1:1,
      loadUrl:''
    }
  },
  methods:{
    initManageCom() {
      let that = this;
      api.post(url.initAllManageCom, {}, function(res) {
        that.options = JSON.stringify(res.data)
          .trim()
          .replace(/"children":\[\],/g, '');
        that.options = JSON.parse(that.options);
        that.manageCom = that.options[0].value;
        that.manageCom1 = that.options[0].value;
        // that.req.manageCom = that.options[0].value;
      });
    },
    search(){
      this.requestData.agentName = this.agentName
      this.requestData.agentCode = this.agentCode
      this.currentPage1 = 1 
      this.requestData.currentPage = this.currentPage1
      if(this.manageCom !== 'HO'){
        this.manageCom.forEach((item,index)=>{
          this.manageComList = item
        })
      }
      if(this.manageComList.length !== 0){
        this.requestData.org = this.manageComList?this.manageComList:'HO'
      }
      this.getSaleAuthRiskTotal()
    },
    getSaleAuthRiskTotal(){
      let that = this
      api.post(url.getSaleAuthRiskTotal, this.requestData, function(res) {
        if(res.result.isSuccess === true){
          that.result = res.data.list,
          that.count = res.data.count
        }
      });
    },
    handleSizeChange(val){
      this.requestData.pageSize = val
      this.getSaleAuthRiskTotal()
    },
    handleCurrentChange(val){
      this.currentPage1 = val
      this.requestData.currentPage = val
      this.getSaleAuthRiskTotal()
    },
    exportResult(){
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let that = this
      api.post(url.exportSaleAuthRiskTotal, this.requestData, function(res) {
        if(res.result.isSuccess === true){
            loading.close()
           that.loadUrl = res.data;
        }else{
          loading.close()
        }
      });
    }
  },
  created(){
    this.initManageCom()
    this.getSaleAuthRiskTotal()
  },
  watch:{
    loadUrl(newValue, oldValue) {
      console.log(newValue);
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = newValue;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  }
}
</script>
<style scoped>
.title1 {
  background: #e0e0e0;
  height: 50px;
  line-height: 50px;
  margin: 0px 0px 0px 0px;
}
.selectColor {
  padding-bottom: 1px;
}
.selectColor >>> .el-cascader{
  width:100%;
}
.selectColor >>> .el-input__inner {
  padding:0 10px;
}
.selectColor >>> .el-select {
  width:100%;
}
.row {
  margin-top: 20px;
  padding-left: 20px;
  line-height: 50px;
}
.right {
  margin: 5px 22px 0 0;
  float: right;
}
.footer {
  padding: 10px 0 30px 0;
}
.my-pagination {
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/pages/exam/examManage/examSaleTotal.vue